var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "button",
    {
      directives: [{ name: "menu-mouse-enter", rawName: "v-menu-mouse-enter" }],
      ref: "mainMenuElement",
      staticClass: "main-menu__button",
      class: {
        "main-menu__button--highlighted": _vm.isHighlighted,
      },
      attrs: {
        id: _vm.uniqueId,
        tabindex: _vm.tabIndex,
        "data-menu-id": _vm.menuId,
        "data-element-id": _vm.analyticsElementId,
        "data-description": _vm.analyticsDescription,
      },
      on: {
        click: function ($event) {
          return _vm.onButtonClick(_vm.menuId)
        },
      },
    },
    [
      _c(
        "div",
        { staticClass: "button__title" },
        [
          _vm._t("icon-left"),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "button__text" },
            [
              _vm._t("title"),
              _vm._v(" "),
              !_vm.isMobile
                ? _c("div", {
                    staticClass: "button__bar",
                    class: {
                      "button__bar--visible": _vm.canShowItemBar,
                      "button__bar--highlighted": _vm.isHighlighted,
                    },
                  })
                : _vm._e(),
            ],
            2
          ),
          _vm._v(" "),
          _vm._t("icon-right"),
        ],
        2
      ),
      _vm._v(" "),
      _vm.isMobile && !_vm.currentMenuId
        ? _c("rb-lazy-icon", {
            attrs: { icon: "caret-big-right", text: "caret-big-right" },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }